import { Component, inject, Input } from '@angular/core';
import { BaseViewComponent, Environment } from '@sb/library/base';
import { SidebarScope } from '../sidebar-item/sidebar-item.component';


@Component({
    selector: 'lib-sidebar-logo',
    templateUrl: './sidebar-logo.component.html',
    styleUrls: ['./sidebar-logo.component.scss']
})
export class SideBarLogoComponent extends BaseViewComponent {
    Scope = this.SetScope({ Requires: SidebarScope });
    private readonly _Environment = inject(Environment);

    @Input() useSchoolName: boolean = false;

    get logoAlt(): string {
        return this._Environment.Application.ProductName ?? $localize`:@@CommonApplicationLogo:Application logo`;
    }
}
